import React from 'react';
import ResetPassword from 'components/website/auth/ResetPassword';

function ResetPasswordPage() {
  return <ResetPassword />;
}

export default ResetPasswordPage;
